///<reference path="../../lib/app.d.ts"/>

import logging from "../utils/log";

export class SpinnerTimer
{
	onReady: Function;

	private TAG = "[Sxc.Chat.SpinnerTimer]";

	private canvas : HTMLCanvasElement;
	private ctx : CanvasRenderingContext2D;

	private CIRCLE_SIZE = 120;
	private CIRCLE_ROUNDTIME = 20000;
	private CIRCLE_STROKEWIDTH = 5;

	/** If this flag is set, the loop will break */
	private cancelled : boolean = false;
	private circleColor: string = '#fff';

	constructor(private $container : JQuery)
	{
		this.canvas = <HTMLCanvasElement> this.$container.find("canvas")[0];
		this.ctx = this.canvas.getContext("2d");
		this.canvas.width = this.canvas.height = this.CIRCLE_SIZE;

		//this.$container.find(".spinner").click(() => {
		//	this.cancel();
		//	this.onReady();
		//});
	}

	doCircle(onReady : Function)
	{
		let startAngle = -0.5 * Math.PI;
		let start = Date.now();
		let center = this.CIRCLE_SIZE / 2;
		let radius = center - this.CIRCLE_STROKEWIDTH / 2;
		let readyCounter = 0;

		let draw = () =>
		{
			this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.cancelled) return;

			let elapsed = Date.now() - start;
			let currAngle = 2 * Math.PI / this.CIRCLE_ROUNDTIME * elapsed;

			this.ctx.beginPath();
			this.ctx.arc(center, center, radius ,startAngle, startAngle + currAngle);
			this.ctx.lineWidth = this.CIRCLE_STROKEWIDTH;
			this.ctx.strokeStyle = this.circleColor;
			this.ctx.stroke();

			if (elapsed > this.CIRCLE_ROUNDTIME) {
				readyCounter++;
			}

			if(readyCounter < 10) {
				requestAnimationFrame(draw);
			} else {
				logging.log(this.TAG, "onReady", onReady);
				if (onReady) onReady();
				onReady = null;
			}
		};

		draw();
	}

	start(params : any) {
	}

	cancel():void
	{
		logging.log(this.TAG, "[cancel]");

		this.cancelled = true;
	}

	idle(screenName : string) : void {
	}
}
